<template>
  <fragment>
    <div class="dropdown-w" v-show="false">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="selectedCompaniesIds" multiple scrollable :max-height="300" aria-role="list" class="multiple custom-checkboxes" :disabled="!companies.length"
              @active-change="onDropdownActiveChange" @change="onCompanyChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t("Leads.CompanyPlaceholder") }} ({{ selectedCompaniesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="companiesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="company in companiesFiltered" :key="company.Id" :value="company.Id" aria-role="listitem">
            <b-checkbox size="is-small" :value="isCompanySelected(company.Id)" disabled></b-checkbox>
            <span>{{ company.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Phones.Tooltips.Filters.Company") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="selectedPhoneStatus" aria-role="list" class="custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onPhoneStatusChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ selectedStatusString }}</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="1">
            <template>
              <span class="indicator indicator-1"></span>
              <span class="label">{{ $t("Enums.PhoneStatus.Active") }}</span>
            </template>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="3">
            <template>
              <span class="indicator indicator-4"></span>
              <span class="label">{{ $t("Enums.PhoneStatus.Released") }}</span>
            </template>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="null">
            <template>
              <span class="label">{{ $t("All") }}</span>
            </template>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Phones.Tooltips.Filters.PhoneStatus") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="selectedChannelMetadataTypesIds" multiple scrollable aria-role="list" class="multiple custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onChannelMetadataTypesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t("Leads.ChannelMetadataPlaceholder") }} ({{ selectedChannelMetadataTypesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="channelMetadataTypesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="channelMetadataType in channelMetadataTypesFiltered" :key="+channelMetadataType.Id" :value="+channelMetadataType.Id"
                aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isChannelMetadataTypeSelected(+channelMetadataType.Id)" disabled></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(channelMetadataType.Id)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(channelMetadataType.Id) + '.png')" />
            </span>
            <span class="text">{{ channelMetadataType.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Phones.Tooltips.Filters.ChannelMetadata") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="selectedCallStatus" aria-role="list" class="custom-checkboxes"
              @active-change="onDropdownActiveChange" @change="onCallStatusChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ selectedCallStatusString }}</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="-1">
            <template>
              <span class="text">{{ $t("Enums.MetadataMaskyooStatus.All") }}</span>
            </template>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="1">
            <template>
              <span class="text">{{ $t("Enums.MetadataMaskyooStatus.Answer") }}</span>
            </template>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" class="is-icon" :value="0">
            <template>
              <span class="text">{{ $t("Enums.MetadataMaskyooStatus.NotAnswer") }}</span>
            </template>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Phones.Tooltips.Filters.CallStatus") }}</p>
        </template>
      </b-tooltip>
    </div>

    <div class="dropdown-w">
      <b-tooltip position="is-bottom" multilined type="is-dark">
        <b-dropdown :value="selectedSourcesIds" multiple scrollable :max-height="300" aria-role="list"
              class="multiple custom-checkboxes" :disabled="!selectedCompaniesIds.length"
              @active-change="onDropdownActiveChange" @change="onSourcesChange($event)">
          <template #trigger>
            <b-button>
              <span class="dropdown-trigger-value">{{ $t("Phones.Grid.Columns.ChannelName") }} ({{ selectedSourcesIds.length }})</span>
              <icon-base width="12" height="7" view-box="0 0 12 7" icon-name="caret-down"><icon-caret-down /></icon-base>
            </b-button>
          </template>
          <b-dropdown-item custom aria-role="listitem" class="filter-search">
            <b-input v-model="sourcesSearch" class="search" :placeholder="$t('Search')" expanded />
          </b-dropdown-item>
          <b-dropdown-item v-for="source in sourcesFiltered" :key="source.Id" :value="source.Id"
                aria-role="listitem" class="dropdown-item-with-icon">
            <b-checkbox size="is-small" :value="isSourceSelected(source.Id)" disabled></b-checkbox>
            <span class="icon-w" v-if="getChannelMetadataTypeIconName(source.ChannelType)">
              <img :src="require('@/assets/' + getChannelMetadataTypeIconName(source.ChannelType) + '.png')" />
            </span>
            <span class="text">{{ source.Title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <template v-slot:content>
          <p>{{ $t("Phones.Tooltips.Filters.Source") }}</p>
        </template>
      </b-tooltip>
    </div>
  </fragment>
</template>

<script lang="ts">
import VueCookies from "vue-cookies";
import Fragment from "vue-fragment";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { AvailableChannelMetadataTypesMode, ChannelType } from "@/models/campaigns/ChannelType";
import { RefreshGridMode } from "@/models/leads/Lead";
import { DataSourceResult } from "@/models/DataSourceResult";
import { MetadataMaskyooStatus } from "@/models/MetadataMaskyooStatus";
import { ChannelMultiselectItem, MultiselectItem } from "@/models/MultiselectItem";
import { PhoneStatus } from "@/models/phones/PhoneWithChannel";
import { PhonesPageData } from "@/models/phones/PhonesPageData";
import CampaignService from "@/services/CampaignService";
import HelperService from "@/services/HelperService";
import IconBase from "../IconBase.vue";
import IconCaretDown from "../icons/IconCaretDown.vue";

Vue.use(Fragment.Plugin);
Vue.use(VueCookies);
const namespace = "phonesModule";

@Component({
  components: {
    IconBase,
    IconCaretDown,
  },
})
export default class PhonesFiltersDropdowns extends Vue {
  
  //#region Vuex getters and actions

  @Getter("channels", { namespace }) channels!: ChannelMultiselectItem[];
  @Getter("companies", { namespace }) companies!: MultiselectItem[];
  @Getter("phones", { namespace }) phones!: DataSourceResult;
  @Getter("phonesPageData", { namespace }) phonesPageData!: PhonesPageData;
  @Getter("selectedCallStatus", { namespace }) selectedCallStatus!: MetadataMaskyooStatus;
  @Getter("selectedChannelMetadataTypesIds", { namespace }) selectedChannelMetadataTypesIds!: number[];
  @Getter("selectedCompaniesIds", { namespace }) selectedCompaniesIds!: number[];
  @Getter("selectedPhoneStatus", { namespace }) selectedPhoneStatus!: PhoneStatus;
  @Getter("selectedSourcesIds", { namespace }) selectedSourcesIds!: string[];
  @Getter("sources", { namespace }) sources!: ChannelMultiselectItem[];
  @Action("setNeedToRefreshPhonesGrid", { namespace }) setNeedToRefreshPhonesGrid!: (needToRefreshPhonesGrid: RefreshGridMode) => void;
  @Action("setSelectedCallStatus", { namespace }) setSelectedCallStatus!: (selectedCallStatus?: MetadataMaskyooStatus) => void;
  @Action("setSelectedChannelMetadataTypesIds", { namespace }) setSelectedChannelMetadataTypesIds!: (selectedChannelMetadataTypesIds: number[]) => void;
  @Action("setSelectedCompaniesIds", { namespace }) setSelectedCompaniesIds!: (selectedCompaniesIds: number[]) => void;
  @Action("setSelectedPhoneStatus", { namespace }) setSelectedPhoneStatus!: (selectedPhoneStatus?: PhoneStatus) => void;
  @Action("setSelectedSourcesIds", { namespace }) setSelectedSourcesIds!: (selectedSourcesIds: string[]) => void;
  @Action("setSources", { namespace }) setSources!: (sources: ChannelMultiselectItem[]) => void;

  //#endregion Vuex getters and actions


  //#region Properties

  channelMetadataTypesSearch = "";
  companiesSearch = "";
  sourcesSearch = "";

  //#endregion Properties


  //#region Watchers

  @Watch("selectedCallStatus", { immediate: true })
  onSelectedCallStatusChange(newValue: MetadataMaskyooStatus, oldValue: MetadataMaskyooStatus): void {
    if (oldValue === undefined || newValue === oldValue) {
      return;
    } else {
      this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedChannelMetadataTypesIds", { immediate: true })
  onSelectedChannelMetadataTypesIdsChange(newSelectedChannelMetadataTypesIds: number[], oldSelectedChannelMetadataTypesIds: number[]): void {
    if (oldSelectedChannelMetadataTypesIds === undefined || newSelectedChannelMetadataTypesIds.length === oldSelectedChannelMetadataTypesIds.length) {
      return;
    } else {
      this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedCompaniesIds", { immediate: true })
  onSelectedCompaniesIdsChange(newSelectedCompaniesIds: number[], oldSelectedCompaniesIds: number[]): void {
    if (oldSelectedCompaniesIds === undefined) {
      return;
    } else {
      this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedPhoneStatus", { immediate: true })
  onSelectedPhoneStatusChange(newValue: PhoneStatus, oldValue: PhoneStatus): void {
    if (oldValue === undefined || newValue === oldValue) {
      return;
    } else {
      this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
    }
  }

  @Watch("selectedSourcesIds", { immediate: true })
  onSelectedSourcesChange(newValues: string[], oldValues: string[]): void {
    if (oldValues === undefined || newValues.length === oldValues.length) {
      return;
    } else {
      this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
    }
  }

  //#endregion Watchers


  //#region Getters

  get channelMetadataTypesFiltered(): MultiselectItem[] {
    return CampaignService.getChannelMetadataTypes(AvailableChannelMetadataTypesMode.Leads, this.channelMetadataTypesSearch.toLowerCase())
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedChannelMetadataTypesIds));
  }

  get companiesFiltered(): MultiselectItem[] {
    return this.companies.filter((i: MultiselectItem) => i.Title.toLowerCase().indexOf(this.companiesSearch.toLowerCase()) >= 0)
      .sort(HelperService.sortMultiselectItemsByIds(this.selectedCompaniesIds));
  }

  get selectedCallStatusString(): string {
    switch (this.selectedCallStatus as MetadataMaskyooStatus) {
      case MetadataMaskyooStatus.All:
        return i18n.t("Phones.TypeOfCall").toString();
      case MetadataMaskyooStatus.Answer:
        return i18n.t("Enums.MetadataMaskyooStatus.Answer").toString();
      case MetadataMaskyooStatus.Callback:
        return i18n.t("Enums.MetadataMaskyooStatus.Callback").toString();
      case MetadataMaskyooStatus.CallMeBackFinished:
        return i18n.t("Enums.MetadataMaskyooStatus.CallMeBackFinished").toString();
      case MetadataMaskyooStatus.CallRouter:
        return i18n.t("Enums.MetadataMaskyooStatus.CallRouter").toString();
      case MetadataMaskyooStatus.NotAnswer:
        return i18n.t("Enums.MetadataMaskyooStatus.NotAnswer").toString();
    }
  }

  get selectedStatusString(): string {
    if (!this.selectedPhoneStatus) {
      return i18n.t("All").toString();
    }
    switch (this.selectedPhoneStatus) {
      case PhoneStatus.Active:
        return i18n.t("Enums.PhoneStatus.Active").toString();
      case PhoneStatus.Released:
        return i18n.t("Enums.PhoneStatus.Released").toString();
    }
    return "";
  }
  
  get sourcesFiltered(): ChannelMultiselectItem[] {
    return this.sources.filter((i: ChannelMultiselectItem) => !this.sourcesSearch || i.Title?.toLowerCase().indexOf(this.sourcesSearch.toLowerCase()) >= 0)
          .sort(HelperService.sortMultiselectItems(this.selectedSourcesIds));
  }

  //#endregion Getters


  //#region Handlers

  onCallStatusChange(callStatus?: MetadataMaskyooStatus): void {
    this.setSelectedCallStatus(callStatus);
    this.setNeedToRefreshPhonesGrid(RefreshGridMode.GraphsOnly);
  }

  onChannelMetadataTypesChange(channelMetadataTypes: ChannelType[]): void {
    this.setSelectedChannelMetadataTypesIds(channelMetadataTypes);
  }

  onCompanyChange(companyIds: number[]): void {
    this.setSources([]);
    this.setSelectedCompaniesIds(companyIds);
  }

  onDropdownActiveChange(show: boolean) {
    HelperService.onDropdownActiveChange(show);
  }

  onPhoneStatusChange(phoneStatus?: PhoneStatus): void {
    this.setSelectedPhoneStatus(phoneStatus);
    this.setNeedToRefreshPhonesGrid(RefreshGridMode.Full);
  }

  onSourcesChange(selectedSourcesIds: string[]): void {
    this.setSelectedSourcesIds(selectedSourcesIds);
  }

  //#endregion Handlers


  //#region Private methods

  private getChannelMetadataTypeIconName(type: string): string {
    return CampaignService.getChannelMetadataTypeIconName(+type);
  }

  //#region Is item selected

  private isChannelMetadataTypeSelected(channelMetadataTypeId: number) {
    return this.selectedChannelMetadataTypesIds.includes(channelMetadataTypeId);
  }

  private isCompanySelected(companiesId: number) {
    return this.selectedCompaniesIds.includes(companiesId);
  }
  
  private isSourceSelected(source: string) {
    return this.selectedSourcesIds.includes(source);
  }

  //#endregion Is item selected
  
  //#endregion Private methods
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.dropdown-w {
  padding: 0 12px 20px;
  width: 15%;
  flex: 0 0 15%;
  @media (max-width: 1599px) {
    width: 33.3333%;
    flex: 0 0 33.3333%;
    @media (resolution: 120dpi) {
      width: 15%;
      flex: 0 0 15%;
    }
  }
  @media (max-width: 1279px) and (resolution: 120dpi) {
    width: 33.3333%;
    flex: 0 0 33.3333%;
  }
  @media (max-width: 991px) {
    width: 50%;
    flex: 0 0 50%;
    padding: 0 8px 15px;
  }
  .b-tooltip {
    width: 100%;
  }

  .dropdown {
    width: 100%;

    .dropdown-item-with-icon {
      display: flex;

      .icon-w {
        align-items: center;
        display: flex;
        margin-inline-end: 0.5rem;
        min-width: 22px;

        img {
          width: 22px;
        }
      }
    }

    .dropdown-trigger {
      width: 100%;

      .button {
        width: 100%;
      }
    }
  }
}

.indicator {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1.5px solid #aaa;
  margin-left: 5px;
  display: block;
  &.indicator-1 {
    background-color: $success;
  }
  &.indicator-2 {
    border-color: $success;
  }
  &.indicator-3 {
  }
  &.indicator-4 {
    background: $danger;
    border-color: $danger;
  }
}

.b-checkbox.checkbox {
  &.is-icon {
    .status {
      display: flex;
      align-items: center;
      .indicator {
        margin-left: 5px;
      }
      .label {
        font-size: 13px;
        font-weight: normal;
      }
    }
  }
}

html[dir="ltr"] {
  .indicator {
    margin: 0 5px 0 0;
  }
  .b-checkbox.checkbox {
    &.is-icon {
      .status {
        .indicator {
          margin: 0 5px 0 0;
        }
      }
    }
  }
}
</style>
